import styled from '@emotion/styled';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { mq } from './_shared/media';
import Logo from '../assets/logo.svg';
import { flexCenter } from './_shared/styled-mixins';

const StyledFooter = styled.footer`
  ${flexCenter};
  width: 100%;
  display: flex;
  flex-direction: column;
  height: auto;
  color: var(--lightbg-content-color);
  text-align: center;
  font-size: 0.8rem;

  ${mq.gt.xs} {
    flex-direction: column;
    justify-content: space-between;
  }
`;

const Top = styled.div`
  ${flexCenter};
  width: 100%;
  flex-direction: column;
  background-color: var(--lightbg-color);
  color: var(--lightbg-content-color);
  padding: 3rem calc((var(--space) / 2));
  text-align: center;
  font-size: 0.9rem;
  display: flex;

  ${mq.gt.xs} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Bottom = styled.div`
  ${flexCenter};
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--lightbg-color);
  color: var(--lightbg-content-color);
  padding: 1rem calc((var(--space) / 2)) 2rem;
  text-align: center;
  font-size: 0.6rem;

  ${mq.gt.sm} {
    flex-direction: row;
    width: 100%;
    justify-content: flex-start;
    text-align: left;
  }
`;

const Left = styled.div`
  height: auto;
`;

const Right = styled.div`
  height: auto;
`;

const StyledNavLink = styled.a`
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 800;
  color: var(--lightbg-content-color) !important;
  border: none;
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;

  &:hover {
    color: var(--secondary-color) !important;
    color: #fff;
  }
`;

const StyledNavLinkSmall = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--footer-small-color) !important;
  margin: 0.5rem 1rem;

  ${mq.lt.sm} {
    text-align: center;
    margin: 0.5rem auto;
    padding: 0.5rem;
  }

  ${mq.gt.xs} {
    justify-content: flex-start;

    &:first-child {
      margin-left: 0;
    }
  }
`;

const StyledLogo = styled(Logo)`
  width: 175px;
  height: auto;
`;

const Footer = ({ author }) => {
  return (
    <StyledFooter>
      <Top>
        <Left>
          <StyledLogo />
          <StyledNavLink />
        </Left>
        <Right>
          <StyledNavLink href="mailto:info@interviewarmy.com">info@interviewarmy.com</StyledNavLink>
        </Right>
      </Top>
      <Bottom>
        <StyledNavLinkSmall to="/">
          <span>
            © {new Date().getFullYear()} {author}
          </span>
        </StyledNavLinkSmall>
        <StyledNavLinkSmall to="/mission">Our Mission</StyledNavLinkSmall>
        <StyledNavLinkSmall to="/diversity">Diversity</StyledNavLinkSmall>
        <StyledNavLinkSmall to="/privacy">Terms and Conditions</StyledNavLinkSmall>
        <StyledNavLinkSmall to="/privacy#ca">Do Not Sell My Personal Information</StyledNavLinkSmall>
      </Bottom>
    </StyledFooter>
  );
};

Footer.propTypes = {
  author: PropTypes.string,
};

Footer.defaultProps = {
  siteTitle: '',
};

export default Footer;
